// Process-wide cache of image natural dimensions, keyed by URL. Populated when the
// solver prefetch warms the next activity's images (useActivityWithDataPrefetch) and
// also on every successful <img> load. Lets the body media renderer reserve the exact
// image box on FIRST paint — before the pixels arrive — so navigating to an activity
// whose picture is preloaded doesn't collapse-then-reflow the surrounding text.
const dimensionCache = new Map<string, { width: number; height: number }>();

export const rememberImageDimensions = (
  url: string | null | undefined,
  width: number,
  height: number,
): void => {
  if (!url || !width || !height) return;
  dimensionCache.set(url, { width, height });
};

export const getImageDimensions = (
  url: string | null | undefined,
): { width: number; height: number } | undefined =>
  url ? dimensionCache.get(url) : undefined;
